import React, { useState } from 'react';
import { StickyTopBar } from './components/layout/StickyTopBar';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { ContactPage } from './pages/ContactPage';
import { ServicePageTemplate } from './pages/ServicePageTemplate';
import { AboutPage } from './pages/AboutPage';
import { LocationPageTemplate } from './pages/LocationPageTemplate';
import { ServicesHub } from './pages/ServicesHub';
import { IndustriesHub } from './pages/IndustriesHub';
import { ResourcesHub } from './pages/ResourcesHub';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { PhoneIcon, ClipboardListIcon } from 'lucide-react';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  // Simple router
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage data-id="element-0" data-mp="23u9u0nodldxa" />;
      case 'contact':
        return <ContactPage data-id="element-1" data-mp="23ti864kkyuk7" />;
      case 'services-hub':
        return <ServicesHub setPage={setCurrentPage} data-id="element-2" data-mp="3ij652c0mxp8x" />;
      case 'services':
        // Individual service template
        return <ServicePageTemplate setPage={setCurrentPage} data-id="element-3" data-mp="3mjzpuwis6nxl" />;
      case 'about':
        return <AboutPage setPage={setCurrentPage} data-id="element-4" data-mp="3rdkisa5iorpx" />;
      case 'location':
        return <LocationPageTemplate setPage={setCurrentPage} data-id="element-5" data-mp="6htjo98ovic" />;
      case 'industries':
        return <IndustriesHub setPage={setCurrentPage} data-id="element-6" data-mp="2zld43f9knpe6" />;
      case 'resources':
        return <ResourcesHub setPage={setCurrentPage} data-id="element-7" data-mp="33mou3lwcycmw" />;
      case 'privacy':
        return <PrivacyPolicy data-id="element-8" data-mp="33ori60dy9voz" />;
      default:
        return <HomePage data-id="element-9" data-mp="38l8eviz7tido" />;
    }
  };
  return <div className="min-h-screen flex flex-col font-body text-charcoal bg-white" data-id="element-10" data-mp="38k6w0sbyjrle">
      <StickyTopBar data-id="element-11" data-mp="3dlntedv8gvx8" />
      <Header setPage={setCurrentPage} currentPage={currentPage} data-id="element-12" data-mp="3dm5y7yvyoigr" />

      <main className="flex-grow" data-id="element-13" data-mp="nuhgse7ce3s6">{renderPage()}</main>

      <Footer setPage={setCurrentPage} data-id="element-14" data-mp="nxx05t81tyze" />

      {/* Sticky Mobile Bottom CTA Bar */}
      <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t border-steel-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 flex" data-id="element-15" data-mp="swqajcs1h9vc">
        <a href="tel:5177778088" className="flex-1 flex items-center justify-center py-4 bg-charcoal text-white font-heading font-bold uppercase tracking-wider text-sm" data-id="element-16" data-mp="3udkn7x6lywax">
          <PhoneIcon className="w-4 h-4 mr-2" data-id="element-17" data-mp="85bc95xfyv4k" />
          Call Now
        </a>
        <button onClick={() => {
        setCurrentPage('contact');
        window.scrollTo(0, 0);
      }} className="flex-1 flex items-center justify-center py-4 bg-brand-red text-white font-heading font-bold uppercase tracking-wider text-sm" data-id="element-18" data-mp="3gl4qfe4avuig">
          <ClipboardListIcon className="w-4 h-4 mr-2" data-id="element-19" data-mp="3lkhe212zx5m3" />
          Get Quote
        </button>
      </div>

      {/* Spacer for mobile bottom bar so content isn't hidden behind it */}
      <div className="h-[56px] md:hidden w-full bg-steel-950" data-id="element-20" data-mp="2xssebznuhev4"></div>
    </div>;
}